import { PeriodChangeListChart, PeriodChangeListChartProps } from '../../../renderers/period-change-list-chart/period-change-list-chart.component';
import { STOCK_VOLUME_BY_PRODUCT_MONTHLY_LIST_CHART_DEFINITION } from './stock-volume-by-product-monthly-list-chart.definition';
import { STOCK_VOLUME_BY_PRODUCT_MONTHLY_LIST_CHART_MOCK_DATA } from './stock-volume-by-product-monthly-list-chart.mock';

export const StockVolumeByProductMonthlyListChart = (props: PeriodChangeListChartProps) => <PeriodChangeListChart {...props} />;

StockVolumeByProductMonthlyListChart.definition = STOCK_VOLUME_BY_PRODUCT_MONTHLY_LIST_CHART_DEFINITION;
StockVolumeByProductMonthlyListChart.mockData = STOCK_VOLUME_BY_PRODUCT_MONTHLY_LIST_CHART_MOCK_DATA;
